import Picker from '@emoji-mart/react'
import Foco from 'react-foco'

import { EmojiPickerProps } from '../Types'

const EmojiPicker = ({ onSelectEmoji, onCancel }: EmojiPickerProps) => {
  return (
    <Foco onClickOutside={onCancel}>
      <Picker onEmojiSelect={onSelectEmoji} autoFocus theme="light" previewPosition="none" />
    </Foco>
  )
}

export { EmojiPicker }
